import React, { useEffect, useState } from "react";
import peabody from "../../assets/img/peabody-logo-teal.png";
import "./style.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { v4 } from "uuid";
import { useLocation } from "react-router-dom";
import * as api from "../../api/index";
import {
  getWorkOrderObject, assetDataResponse, woChronologyTabState, assetDataStatus, customerList, customersData, keyContact, localAuthority, loginStatus, userChoicesPermissions, userChosenAccountData, userChosenAccountNumber, userChosenBackButton, userChosenRaisedSince, userChosenRaisedUpto, userChosenSearchText, userChosenSearchType, userChosentenancyGroup,
  userChosenBackValue, userChosenCustomerID, componentInformation, hierarchyOfPremises, userChosenAlertValue, propertyListData, workList, transactionInformation, userChosenDuplicateEntity, userChosenCurrentValue, checkForLandlord, createCasePermissions, isRepairMediAllowed, isRepairCovidAllowed, appConfigVandalismToggle, searchTextCountValue, isCaseAllowed,
  demobilizedContractorSites, isP360RepairsMaintainence, setUserEmail, assetPropertyId, checkEnhancedRepairEligibilityP360, saveEdEnabled, saveDMQuestionnaireEnabled, saveDMReportPreferenceEnabled, saveHHRSReportPreferenceEnabled, saveDMReportingComplianceEffectiveDate, setRepairDiagnosticFinalData, userChosenSOR, userChosenRepairLocationId, userChosenHighLevelDescription, userChosenEmergencyQuestion, userChosenNotifyAll, userChosenEligibilityErrorCode,
  edConfigOverrideUrl,
  edConfigCustomer,
  edConfigActiveHousingScriptUrl,
  saveAdditionalDMWorkOrderRequired,
  saveWOCreationPollingDelaySeconds,
  saveWOCreationTimeoutSeconds,
  saveAvailabilityWaitTimeSeconds,
  saveRecallEligibilityPeriodInMonths,
  saveWOCancellationPollingDelaySeconds,
  saveWOCancellationTimeoutSeconds,
  skipResponsibilityCheckForEMA,
  saveIsHHSRSRepairEnabled
} from "../../ducks/redux/actions/userChoices";
import { getContractorName, getReferenceNumber, saveCustomerDetails, workOrderRepairObject, saveSupplimentaryCodes, saveIsEligibleForEnhancedDiagnostics, saveCurrentAssetEligibilityDetails, saveSubSessionAssetsEligibilityDetails } from "../../ducks/redux/actions/getAddress";
import Hotjar from '@hotjar/browser'
import { PermissionsList } from "../../models/Permissions";
import { isNullOrUndefined } from "../../utils/formatting";
import useBackToTop from '../../compositions/BackToTop/useBackToTop'
import { IS_CASEMANAGEMENT_TOGGLE, IS_UPDATEANACTION_TOGGLE } from "../../ducks/redux/actionTypes";
import { assetBackCouterDispatch, releaseAssetArrayDispatch, savingServiceCardData, gasBoilderData, removeAllDMCData, storeAPIErrors, getSearchTypeCustomerRemoveData, getSearchPropertyRemoveData, getSearchTypeWorkOrderDataRemove, getSearchTypeServiceRequestDataRemove, getSearchTypeSortDataRemove, getCaseAssignToMeDataRemove, storeSORDAMP, saveIsHHSRSEnabledP360Toggle, saveHazardType, saveSaverityScore, saveHHSRSOption } from "../../ducks/redux/actions/FinancialReferral";
import { selectedRepairReasonPriorityOverride } from "../../ducks/redux/actions/dashboardReducer.actions";
import { resetReduxState } from "../../utils/resetReduxState/resetReduxState";
import { resetHazardAssessmentData, saveHazardDetails } from "../../ducks/redux/actions/hazardAssessment";

const adLogoutUrl: string = process.env.REACT_APP_CSS_AD_LOGOUT_URL || "";
const siteId = process.env.REACT_APP_SITE_ID || ''; const hotjarVersion = process.env.REACT_APP_HOTJAR_VERSION || '';
const edmsLink = process.env.REACT_APP_EDMS_LINK;
const openVantage = process.env.REACT_APP_VANTAGE_LINK ?? 'https://ergocrmpoc-peabodygroup.msappproxy.net/ERGO/main.aspx';


type HeaderProps = {
};
const Header: React.FC<HeaderProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { width } = useBackToTop()
  const [navBarFun, setNavBarFun] = useState("none");
  const [isVisibleSignOut, setIsVisibleSignOut] = useState("none");
  const [showvantagelink, setshowvantagelink] = useState(false);
  const [userName, setUserName] = useState('');
  const location = useLocation();
  const queryStringSearch = location?.search || "";
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );

  const userChoicesReducer = useSelector(
    (state: any) => state?.userChoicesReducer
  );
  const financialReferralReducer = useSelector(
    (state: any) => state?.FinancialReferralReducer
  );

  const caseCreationReducer = useSelector(
    (state: any) => state?.caseCreationReducer
  );

  useEffect(() => {
    if (width <= 820) {
      setNavBarFun("none");
    }
  }, [width])

  const navBarFunction = () => {
    if (navBarFun === "none")
      setNavBarFun("block");
    else
      setNavBarFun("none");
  }
  const goToHome = () => {
    dispatch(assetPropertyId(""))
    dispatch(releaseAssetArrayDispatch(null))
    dispatch(assetBackCouterDispatch(0))
    if (history.location.pathname === "/LandingView" || history.location.pathname === "/" || history.location.pathname === "/Login")
      window.location.reload();
    else
      history.push("/LandingView");
  }
  const clearCommonReduxStates = () => {
    // removing all dmc answers when user changes the additional information
    dispatch(removeAllDMCData(null));
    dispatch(savingServiceCardData(""));
    dispatch(gasBoilderData(null));
    dispatch(releaseAssetArrayDispatch(null));
    dispatch(assetBackCouterDispatch(0));
    dispatch(demobilizedContractorSites([]));
    dispatch(loginStatus(false));
    dispatch(workOrderRepairObject(null));
    dispatch(workList(null));
    dispatch(propertyListData(null));
    dispatch(getReferenceNumber(null));
    dispatch(userChosenAccountNumber(""));
    dispatch(userChosentenancyGroup(""));
    dispatch(saveCustomerDetails(""));
    dispatch(
      userChosenAccountData("")
    );
    dispatch(userChoicesPermissions(null));
    dispatch(getWorkOrderObject(null));
    dispatch(customersData(""));
    dispatch(userChosenBackButton(false));
    dispatch(userChosenSearchText(null));
    dispatch(userChosenSearchType(null));
    dispatch(userChosenRaisedSince(null));
    dispatch(userChosenRaisedUpto(null));
    dispatch(customerList(null));
    dispatch(assetDataStatus(""));
    dispatch(assetDataResponse(null));
    dispatch(localAuthority(""));
    dispatch(keyContact(null));
    dispatch(userChosenBackValue(""));
    dispatch(userChosenDuplicateEntity(""));
    dispatch(userChosenCurrentValue(""));
    dispatch(userChosenCustomerID(""));
    dispatch(componentInformation(""));
    dispatch(transactionInformation(""));
    dispatch(hierarchyOfPremises(null));
    dispatch(woChronologyTabState(""));
    dispatch(userChosenAlertValue(null));
    dispatch(checkForLandlord(false));
    dispatch(searchTextCountValue(null));
    dispatch(isRepairMediAllowed(""));
    dispatch(appConfigVandalismToggle(null));
    dispatch(isRepairCovidAllowed(null));
    dispatch(isCaseAllowed(null));
    dispatch(saveSupplimentaryCodes(""));
    dispatch({ type: IS_CASEMANAGEMENT_TOGGLE, payload: null });
    dispatch({ type: IS_UPDATEANACTION_TOGGLE, payload: null });
    dispatch(checkEnhancedRepairEligibilityP360(null));
    dispatch(saveEdEnabled(null));
    dispatch(getContractorName(null));
    dispatch(gasBoilderData(null));
    dispatch(saveIsEligibleForEnhancedDiagnostics(null));
    dispatch(setRepairDiagnosticFinalData(null));
    dispatch(selectedRepairReasonPriorityOverride(""));
    dispatch(userChosenSOR(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenNotifyAll(null));
    dispatch(userChosenEligibilityErrorCode(null));
    dispatch(edConfigOverrideUrl(""));
    dispatch(edConfigCustomer(""));
    dispatch(edConfigActiveHousingScriptUrl(""));
    dispatch(saveCurrentAssetEligibilityDetails(null));
    dispatch(saveSubSessionAssetsEligibilityDetails([]));
    dispatch(storeAPIErrors([]));
    dispatch(storeSORDAMP(null));
    dispatch(skipResponsibilityCheckForEMA(null));
  };

  const RedirectToLogoutPage = () => {
    (async function () {
      try {
        resetReduxState(dispatch, {});
        // Resetting all filtered data as default value
        dispatch(getSearchTypeCustomerRemoveData({ setCustomerStatus: "", setTenancyType: "" }));
        dispatch(getSearchPropertyRemoveData({ setPropertyStatus: "", setPropertyType: "" }));
        dispatch(getSearchTypeWorkOrderDataRemove({ setWorkOrderPropertyType: "", setStatusWorkOrderType: "", setPriorityWorkOrder: "" }));
        dispatch(getSearchTypeServiceRequestDataRemove({ setCasePropertyType: "", setCaseStatusFilterType: "" }));
        dispatch(getSearchTypeSortDataRemove(""))
        dispatch(getCaseAssignToMeDataRemove(""));
        dispatch(saveHazardType(''));
        dispatch(saveSaverityScore(''));
        dispatch(saveHHSRSOption("no"));
        dispatch(resetHazardAssessmentData());
        await api.clearSession();
        localStorage.clear();
        sessionStorage.clear();
        setUserName('');
        window.location.href = adLogoutUrl;
        history.push('/Login');
      }
      catch (e) {
        console.log(e);
        setTimeout(() => {
          history.push("/GenericError");
        }, 1000);
      }
    })();
  };

  const RedirectToPermissionPage = () => {
    (async function () {
      try {
        clearCommonReduxStates();
        localStorage.clear();
        sessionStorage.clear();
        setUserName('');
        history.push('/PermissionError');
      }
      catch (e) {
        console.log(e);
        setTimeout(() => {
          history.push("/GenericError");
        }, 1000);
      }
    })();
  };
  const hotjarScriptCall = async () => {
    const appConfigHotjarToggleValue = await api.GetAppConfigToggleValue(
      "IsHotjarEnabledColleague"
    );
    if (appConfigHotjarToggleValue?.value.toLowerCase() === 'true') {
      Hotjar.init(Number(siteId), Number(hotjarVersion));
    }

  }


  let toggleLogin = async (loggedInStatus: Boolean) => {
    if (!loggedInStatus) {
      setIsVisibleSignOut("none");
    }
    else {
      setIsVisibleSignOut("block");
      hotjarScriptCall();

      const email = localStorage.getItem("email");
      if (email) {
        dispatch(setUserEmail(email));
      }
      await retrievePermissions(localStorage.getItem('agent') || "");
      retrieveAppConfigs();
    }
    dispatch(loginStatus(loggedInStatus));
  }

  let retrievePermissions = async (xAgentIdentifier: string) => {

    if (xAgentIdentifier !== "" && isNullOrUndefined(getPermissionsData)) {
      // Retrieve Permissions only if XAgentIdentifier exists in Local Storage + Permission Data is not available in Redux store
      let permissionsResponded = await api.getpermissions(xAgentIdentifier as string);
      if (permissionsResponded?.permissions[0] !== undefined) {
        dispatch(userChoicesPermissions(permissionsResponded?.permissions));
        dispatch(loginStatus(true));
        setshowvantagelink(permissionsResponded?.permissions?.indexOf(PermissionsList.view_vantage_link) > -1);
      }
      else {
        dispatch(userChoicesPermissions(null));
        RedirectToPermissionPage();
        return
      }

      if (permissionsResponded?.casePermissions?.restrictedCreateSubCategoriesList?.length > 0) {
        dispatch(createCasePermissions(permissionsResponded?.casePermissions?.restrictedCreateSubCategoriesList));
      }
    }
  }

  const retrieveHazardDetails = async () => {
    try {
      const hazardDetails = await api.getHazards();
      dispatch(saveHazardDetails(hazardDetails));
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  let retrieveAppConfigs = async () => {
    let env = process.env.REACT_APP_ENV || '',
      edEnabledKey = `isEDEnabledP360`;
    let isP360HHSRSEnabled = `P360:isHHSRSEnabled`;
    let isHHRSPreferenceEnabled = `P360:isHHSRSPreferenceQuestionEnabled`;
    let isP360HHSRSRepairEnabled = `P360:isHHSRSRepairEnabled`;
    let skipRespKey = `P360:skipResponsibilityCheckForEMA`;
    if (process.env.REACT_APP_ENV_NONPROD_APPCONFIG === "true") {
      isP360HHSRSEnabled = `${env}:P360:isHHSRSEnabled`;
      isP360HHSRSRepairEnabled = `${env}:P360:isHHSRSRepairEnabled`;
      isHHRSPreferenceEnabled = `${env}:P360:isHHSRSPreferenceQuestionEnabled`;
    }
    //need to refactor below configuration, Please don't add any other condition
    if (!isNullOrUndefined(process.env.REACT_APP_ENV_NO)) {
      env = env + process.env.REACT_APP_ENV_NO;
      edEnabledKey = `${env}_P360_isEDEnabled`;
      skipRespKey = `${env}:P360:skipResponsibilityCheckForEMA`;
    }


    var requiredAppConfigs = [];
    requiredAppConfigs.push(
      { key: "SearchTextCount", reduxReducerKey: userChoicesReducer?.searchTextCountValue },
      { key: "isRepairMediaAllowed", reduxReducerKey: userChoicesReducer?.isRepairMediaAllowed },
      { key: "isVandalismQuestionColleagueRequired", reduxReducerKey: userChoicesReducer?.vandalismtoggleValue },
      { key: "isCovidQuestionColleagueRequired", reduxReducerKey: userChoicesReducer?.isRepairCovidAllowed },
      { key: "isCaseAllowed", reduxReducerKey: userChoicesReducer?.isCaseAllowed },
      { key: "isCaseManagement", reduxReducerKey: caseCreationReducer?.isCaseManagementToggle },
      { key: "IsUpdateAnActionToggle", reduxReducerKey: caseCreationReducer?.isUpdateAnActionToggle },
      { key: "demobilizedContractorSites", reduxReducerKey: userChoicesReducer?.demobilizedContractorSites },
      { key: "isP360RepairsMaintainence", reduxReducerKey: userChoicesReducer?.demobilizedContractorSites },
      { key: "checkEnhancedRepairEligibilityP360", reduxReducerKey: userChoicesReducer?.checkEnhancedRepairEligibilityP360 },
      { key: edEnabledKey, reduxReducerKey: userChoicesReducer?.isEDEnabled },
      { key: "edConfigOverrideUrl", reduxReducerKey: userChoicesReducer?.edConfigOverrideUrl },
      { key: "edConfigCustomer", reduxReducerKey: userChoicesReducer?.edConfigCustomer },
      { key: "edConfigActiveHousingScriptUrl", reduxReducerKey: userChoicesReducer?.edConfigActiveHousingScriptUrl },
      { key: "P360:isDMQuestionnaireEnabled", reduxReducerKey: userChoicesReducer?.isDMQuestionnaireEnabled },
      { key: "P360:ReportingComplianceEffectiveDate", reduxReducerKey: userChoicesReducer?.DMReportingComplianceEffectiveDate },
      { key: isHHRSPreferenceEnabled, reduxReducerKey: userChoicesReducer?.isHHRSReportPreferenceEnabled },
      { key: "P360:isDMReportPreferenceEnabled", reduxReducerKey: userChoicesReducer?.isDMReportPreferenceEnabled },
      { key: "P360:isAdditionalDMWorkOrderRequired", reduxReducerKey: userChoicesReducer?.isAdditionalDMWorkOrderRequired },
      { key: "P360:WOCreationTimeoutSeconds", reduxReducerKey: userChoicesReducer?.woCreationTimeoutSeconds },
      { key: "P360:WOCreationPollingDelaySeconds", reduxReducerKey: userChoicesReducer?.woCreationPollingDelaySeconds },
      { key: "P360:WOCancellationTimeoutSeconds", reduxReducerKey: userChoicesReducer?.woCancellationTimeoutSeconds },
      { key: "P360:WOCancellationPollingDelaySeconds", reduxReducerKey: userChoicesReducer?.woCancellationPollingDelaySeconds },
      { key: "P360:AvailabilityWaitTime", reduxReducerKey: userChoicesReducer?.availabilityWaitTimeSeconds },
      { key: "P360:RecallEligibilityPeriodInMonths", reduxReducerKey: userChoicesReducer?.recallEligibilityPeriodInMonths },
      { key: "dmcsorcodes", reduxReducerKey: financialReferralReducer?.sordamp },
      { key: skipRespKey, reduxReducerKey: userChoicesReducer?.skipResponsibilityCheckForEMA },
      { key: isP360HHSRSEnabled, reduxReducerKey: financialReferralReducer?.isHHSRSEnabled },
      { key: isP360HHSRSRepairEnabled, reduxReducerKey: userChoicesReducer?.isHHSRSRepairEnabled }
    );

    var requiredAppConfigCalls = requiredAppConfigs.map(
      (requiredConfig) => {
        if (!requiredConfig?.reduxReducerKey) {
          return api.GetAppConfigToggleValue(requiredConfig.key)
        }
      }
    );

    Promise.allSettled(requiredAppConfigCalls).then(appConfigResponses => {
      appConfigResponses?.forEach(appConfigResponse => {
        if (appConfigResponse?.status === "fulfilled" && !isNullOrUndefined(appConfigResponse.value?.value)) {
          switch (appConfigResponse.value?.key) {
            case isP360HHSRSRepairEnabled: {
              dispatch(saveIsHHSRSRepairEnabled(appConfigResponse.value?.value?.toLowerCase() === "true"));
              break;
            }
            case "isP360RepairsMaintainence":
              dispatch(isP360RepairsMaintainence(appConfigResponse.value?.value?.toLowerCase() === "true" ? true : false));
              break;
            case "SearchTextCount":
              dispatch(searchTextCountValue(appConfigResponse.value?.value));
              break;
            case "isRepairMediaAllowed":
              dispatch(isRepairMediAllowed(appConfigResponse.value?.value));
              break;
            case "isVandalismQuestionColleagueRequired":
              dispatch(appConfigVandalismToggle(appConfigResponse.value?.value.toLowerCase() === "true" ? true : false));
              break;
            case "isCovidQuestionColleagueRequired":
              dispatch(isRepairCovidAllowed(appConfigResponse.value?.value.toLowerCase() === "true" ? true : false));
              break;
            case "demobilizedContractorSites":
              dispatch(demobilizedContractorSites(appConfigResponse.value?.value?.split(",")));
              break;
            case "isCaseAllowed":
              dispatch(isCaseAllowed(appConfigResponse.value?.value));
              break;
            case "isCaseManagement":
              dispatch({ type: IS_CASEMANAGEMENT_TOGGLE, payload: appConfigResponse.value?.value.toLowerCase() === "true" ? true : false });
              break;
            case "IsUpdateAnActionToggle":
              dispatch({ type: IS_UPDATEANACTION_TOGGLE, payload: appConfigResponse.value?.value.toLowerCase() === "true" ? true : false });
              break;
            case "checkEnhancedRepairEligibilityP360":
              dispatch(checkEnhancedRepairEligibilityP360(appConfigResponse.value?.value.toLowerCase() === "true"));
              break;
            case edEnabledKey:
              dispatch(saveEdEnabled((appConfigResponse?.value?.value?.toLowerCase() === "true")));
              break;
            case "edConfigOverrideUrl":
              dispatch(edConfigOverrideUrl(appConfigResponse.value?.value));
              break;
            case "edConfigCustomer":
              dispatch(edConfigCustomer(appConfigResponse.value?.value));
              break;
            case "edConfigActiveHousingScriptUrl":
              dispatch(edConfigActiveHousingScriptUrl(appConfigResponse.value?.value));
              break;
            case "P360:isDMQuestionnaireEnabled":
              dispatch(saveDMQuestionnaireEnabled(appConfigResponse.value?.value?.toLowerCase() === "true"));
              break;
            case "P360:isDMReportPreferenceEnabled":
              dispatch(saveDMReportPreferenceEnabled(appConfigResponse.value?.value?.toLowerCase() === "true"));
              break;
            case isHHRSPreferenceEnabled:
              dispatch(saveHHRSReportPreferenceEnabled(appConfigResponse.value?.value?.toLowerCase() === "true"));
              break;
            case "P360:ReportingComplianceEffectiveDate":
              dispatch(saveDMReportingComplianceEffectiveDate(appConfigResponse.value?.value));
              break;
            case "P360:isAdditionalDMWorkOrderRequired":
              dispatch(saveAdditionalDMWorkOrderRequired(appConfigResponse.value?.value?.toLowerCase() === "true"));
              break;
            case "P360:WOCreationTimeoutSeconds": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveWOCreationTimeoutSeconds(n));
              break;
            }
            case "P360:WOCreationPollingDelaySeconds": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveWOCreationPollingDelaySeconds(n));
              break;
            }
            case "P360:WOCancellationTimeoutSeconds": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveWOCancellationTimeoutSeconds(n));
              break;
            }
            case "P360:WOCancellationPollingDelaySeconds": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveWOCancellationPollingDelaySeconds(n));
              break;
            }
            case "P360:AvailabilityWaitTime": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveAvailabilityWaitTimeSeconds(n));
              break;
            }
            case "P360:RecallEligibilityPeriodInMonths": {
              const n = Number(appConfigResponse.value?.value);
              dispatch(saveRecallEligibilityPeriodInMonths(n));
              break;
            }
            case "dmcsorcodes":
              dispatch(storeSORDAMP(appConfigResponse.value?.value));
              break;
            case skipRespKey:
              dispatch(skipResponsibilityCheckForEMA(appConfigResponse.value?.value.toLowerCase() === "true"));
              break;
            case isP360HHSRSEnabled:
              dispatch(saveIsHHSRSEnabledP360Toggle(appConfigResponse.value?.value.toLowerCase() === "true"));
              break;

            default:
              break;
          }
        }
      });
    });
    retrieveHazardDetails();
  };

  const authCode = new URLSearchParams(queryStringSearch).get("code") || "";
  const urlStateVal = new URLSearchParams(queryStringSearch).get("state") || "";

  
  useEffect(() => {
    const hasPermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_vantage_link) > -1;
    if (hasPermission) {
      setshowvantagelink(hasPermission)
    }
    window.scrollTo(0, 0);
    let tokenDataResponded;
    if (!isUndefinedNullOrEmpty(authCode)) {
      localStorage.setItem('authCode', authCode);
      localStorage.setItem('login', 'true');
      if (localStorage.getItem('userName') === "" || localStorage.getItem('userName') === null || localStorage.getItem('userName') === undefined) {
        localStorage.setItem('sessionId', v4());
        localStorage.setItem('corelationId', v4());
        dispatch(userChosenBackButton(false));
        dispatch(userChosenSearchText(null));
        dispatch(userChosenSearchType(null));
        dispatch(userChosenRaisedSince(null));
        dispatch(userChosenRaisedUpto(null));
        (async function () {
          tokenDataResponded = await api.GetUserName(authCode as string);
          localStorage.setItem('agent', tokenDataResponded?.id);
          localStorage.setItem('userName', tokenDataResponded?.name);
          localStorage.setItem('email', tokenDataResponded?.email);
          localStorage.setItem('user_department', tokenDataResponded?.department);
          localStorage.setItem('user_role', tokenDataResponded?.roles);
          localStorage.setItem('user_companyName', tokenDataResponded?.companyName);
          toggleLogin(true);

          await retrievePermissions(tokenDataResponded?.id);
          retrieveAppConfigs();
          

          setUserName(tokenDataResponded?.name);
          if (urlStateVal !== '' && urlStateVal !== null && urlStateVal.toLowerCase().includes('workorder360view')) {
            history.push(urlStateVal);
          } else {
            history.push('/LandingView');
          }
        })()
      }
    } else {
      toggleLogin(localStorage.getItem('login') ? true : false);
    }

  }, [localStorage.getItem("agent")]);

  const handleEDMS = () => {
    window.open(edmsLink, "_blank", "noopener");
  }
  const handleVantageLink = () => {
    window.open(openVantage, "_blank");
  }
  return (
    <nav className="navbar navbar-expand-lg navbar-light py-2 border-bottom">
      <div className="container">
        <a data-testid="peabody_logo" className="navbar-brand cursor-pointer" onClick={goToHome}>
          <img className="img-fluid w-3/4 md:w-auto pl-1" src={peabody} alt="Peabody Logo" />
        </a>
        <>
          {width <= 820 && (localStorage.getItem('login') === "true") && <button className="hm-menu pl-nav mr-2 burgur-bg" data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
            aria-label="Toggle navigation" data-testid="mobile-menu"
          >
            <span><input type="checkbox" id="checkbox3" className="checkbox3 visuallyHidden" onClick={navBarFunction} />
              <label htmlFor="checkbox3">
                <span className="visually-hidden">Label for the input</span>
                <div className="hamburger hamburger3">
                  <span className="bar bar1"></span>
                  <span className="bar bar2"></span>
                  <span className="bar bar4"></span>
                </div>
              </label>
            </span>
          </button>}
          {(localStorage.getItem('login') === "true") && <div className="collapse navbar-collapse global-txt containerBurger" id="navbarResponsive"
            style={{ display: navBarFun }} >

            <ul className="navbar-nav ms-auto my-2 my-lg-0 px-2">
              {showvantagelink && <li className="nav-item cursor-pointer" style={{ display: isVisibleSignOut }}
                onClick={handleVantageLink} onKeyPress={handleVantageLink}><span className="nav-link active-link">{t('open_Vantage')}</span></li>}
              {Array.isArray(getPermissionsData) && getPermissionsData?.includes(PermissionsList.view_edms_link) && (
                <li className="nav-item cursor-pointer" style={{ display: isVisibleSignOut }}
                  onClick={handleEDMS} onKeyPress={handleEDMS}>
                  <span className="nav-link active-link">{t('eDMS')}</span>
                </li>
              )}
              <li className="nav-item cursor-pointer" style={{ display: isVisibleSignOut }}
              ><span className="nav-link"><i className="fas fa-user text-teal pr-2"></i>{userName ? userName : localStorage.getItem('userName')}</span></li>
              <li className="nav-item cursor-pointer" style={{
                display: isVisibleSignOut
              }} onClick={RedirectToLogoutPage} ><span className="nav-link"><i className="fa fa-sign-out text-teal pr-2"></i>{t("Logout")}</span></li>
            </ul>
          </div>}
        </>

      </div>
    </nav>

  )
};
export default Header;